import { render, staticRenderFns } from "./Lgx178553336239226880.vue?vue&type=template&id=9ffa9d12&"
import script from "./Lgx178553336239226880.vue?vue&type=script&lang=js&"
export * from "./Lgx178553336239226880.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports